import { Stack, Text } from "@certn/cascadia";
import { Divider } from "@certn/cascadia-react";
import { getRegionFromUrl } from "@certn/utils";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { CoreLogin } from "./CoreLogin";
import { InterCheckLogin } from "./InterCheckLogin";

export function OtherServicesCard() {
  const { t } = useTranslation();
  const region = getRegionFromUrl();
  return (
    <Stack className={styles.stack}>
      <div className={styles.otherServicesContainer}>
        <Divider className={styles.divider} />
        <Text
          style="form/section-heading"
          color="text-weak"
          className={styles.text}
        >
          {t("Other services")}
        </Text>

        <Divider className={styles.divider} />
      </div>

      {region === "au" ? (
        <>
          <InterCheckLogin />
          <CoreLogin />
        </>
      ) : (
        <>
          <CoreLogin />
          <InterCheckLogin />
        </>
      )}
    </Stack>
  );
}

const styles = {
  otherServicesContainer: css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "var(--space-4) 0",
  }),
  divider: css({
    width: "50%",
  }),
  text: css({
    textAlign: "center",
    display: "block",
    margin: "0 var(--space-4)",
    whiteSpace: "nowrap",
  }),
  stack: css({
    marginBottom: "var(--space-12)",
    width: "89%",
  }),
};
